export const ApiUrl = "https://cms.loreto.in/api";

export const ReligioUrl = "https://app.loreto.in/api";

// export const ReligioUrl = "http://testloreto.cristolive.org/api"
